import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { loginRequest } from "../authConfig";
import { AppRole, getAppRole } from "../utils/AppRole";
import { appConfig } from "../appConfig";
import { MetricsCard } from "../components/MetricsCard";

interface MetricsProps {
  newNrufCount: number,
  newPart1Count: number,
  newPart1BCount: number,
  newPart4Count: number,
  newPart5Count: number,
  workingPart1BCount: number,
  workingPart5Count: number,
  processedPart1BCount: number,
  processedPart5Count: number
}

export function Home() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [accessToken, setAccessToken] = useState("");
  const [metrics, setMetrics] = useState<MetricsProps>();

  useEffect(() => {
    if (!isAuthenticated) return;
    instance
      .acquireTokenSilent(loginRequest)
      .then(function (accessTokenResponse) {
        // Acquire token interactive success
        setAccessToken(accessTokenResponse.accessToken);
        // check Role
        const role = getAppRole(accessTokenResponse.accessToken);
        if (role == AppRole.Administrator) {

          fetch(`${appConfig.api.url}/api/home`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessTokenResponse.accessToken}`,
            },
          })
            .then((response) => response.json())
            .then((response) => {
              setMetrics(response);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [instance, isAuthenticated]);

  return (
    <>
      <AuthenticatedTemplate>
        {metrics &&
          <>
            <MetricsCard title="NRUF" count={metrics.newNrufCount} showMore={false} link="/files" />
            <MetricsCard title="Part 1" count={metrics.newPart1Count} showMore={false} link="/admin-form-one" />
            <MetricsCard title="Part 1B" count={metrics.newPart1BCount} showMore={true}
              processed={metrics.processedPart1BCount} working={metrics.workingPart1BCount} link="/admin-form-one-b" />
            <MetricsCard title="Part 4" count={metrics.newPart4Count} showMore={false} link="/admin-form-four" />
            <MetricsCard title="Part 5" count={metrics.newPart5Count} showMore={true}
              processed={metrics.processedPart5Count} working={metrics.workingPart5Count} link="/admin-form-five" />
          </>
        }
      </AuthenticatedTemplate>
    </>
  );
}
